module.exports = __webpack_public_path__ + "img/Problem_fluid_Taps.c6642091.svg";